import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { LocalizedContent, whatsappLink } from '../../data/siteContent';
type Props = {
  content: LocalizedContent;
};
export function WhatsAppFloat({
  content
}: Props) {
  return <a href={whatsappLink(content.whatsapp.message)} target="_blank" rel="noopener noreferrer" aria-label={content.whatsapp.ariaLabel} className="fixed bottom-[calc(1rem+env(safe-area-inset-bottom))] right-4 z-50 flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-[#123b25]/85 text-[var(--ms-gold-soft)] shadow-[0_16px_45px_-14px_rgba(0,0,0,0.72)] backdrop-blur-md transition-colors hover:border-[var(--ms-gold-soft)] hover:bg-[#17492d] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ms-gold-soft)] sm:bottom-7 sm:right-7 sm:h-12 sm:w-12" data-id="element-195" data-mp="20i9u6kdgzore">
      <MessageCircleIcon className="h-[18px] w-[18px] sm:h-5 sm:w-5" data-id="element-196" data-mp="2t8i63uhexcxj" />
    </a>;
}